import {
  DELETE_SMC_CARS_ERROR,
  DELETE_SMC_CARS_REQUEST,
  DELETE_SMC_CARS_SUCCESS,
  GET_SMC_CARS_ERROR,
  GET_SMC_CARS_REQUEST,
  GET_SMC_CARS_SUCCESS,
  POST_ADD_SMC_CARS_ERROR,
  POST_ADD_SMC_CARS_REQUEST,
  POST_ADD_SMC_CARS_SUCCESS,
  CLEAR_ERROR,
} from './constants';

export const getSMCCarsRequest = () => ({
  type: GET_SMC_CARS_REQUEST,
});

export const getSMCCarsSuccess = (response: any) => ({
  type: GET_SMC_CARS_SUCCESS,
  payload: response,
});

export const getSMCCarsError = (error: any) => ({
  type: GET_SMC_CARS_ERROR,
  payload: error,
});

export const postAddSMCCarsRequest = (body: any) => ({
  type: POST_ADD_SMC_CARS_REQUEST,
  payload: body,
});

export const postAddSMCCarsSuccess = (response: any) => ({
  type: POST_ADD_SMC_CARS_SUCCESS,
  payload: response,
});

export const postAddSMCCarsError = (error: any) => ({
  type: POST_ADD_SMC_CARS_ERROR,
  payload: error,
});

export const deleteSMCCarsRequest = (id: number) => ({
  type: DELETE_SMC_CARS_REQUEST,
  payload: id,
});

export const deleteSMCCarsSuccess = () => ({
  type: DELETE_SMC_CARS_SUCCESS,
});

export const deleteSMCCarsError = (error: any) => ({
  type: DELETE_SMC_CARS_ERROR,
  payload: error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export type Actions =
  | ReturnType<typeof deleteSMCCarsRequest>
  | ReturnType<typeof deleteSMCCarsSuccess>
  | ReturnType<typeof deleteSMCCarsError>
  | ReturnType<typeof getSMCCarsRequest>
  | ReturnType<typeof getSMCCarsSuccess>
  | ReturnType<typeof getSMCCarsError>
  | ReturnType<typeof postAddSMCCarsRequest>
  | ReturnType<typeof postAddSMCCarsSuccess>
  | ReturnType<typeof postAddSMCCarsError>
  | ReturnType<typeof clearError>;
